export const isTouchDevice = (): boolean =>
  "ontouchstart" in window || window.navigator.maxTouchPoints > 0;

const MAX_MOBILE_WIDTH = 768;
const MAX_TABLET_WIDTH = 1180;

const isDeviceWidth = (maxWidth: number): boolean => {
  const orientationAngle =
    // safari doesn't support orientation api
    // https://developer.mozilla.org/en-US/docs/Web/API/Screen_Orientation_API
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    (!!window.screen.orientation && window.screen.orientation.angle) ||
    window.orientation ||
    0;
  const isLandscape =
    orientationAngle === 90 ||
    orientationAngle === 270 ||
    window.screen.height < window.screen.width; // fallback for safari

  return isLandscape
    ? window.screen.height < maxWidth
    : window.screen.width < maxWidth;
};

export const isMobileWidth = (): boolean => {
  return isDeviceWidth(MAX_MOBILE_WIDTH);
};

export const isTabletWidth = (): boolean => {
  return isDeviceWidth(MAX_TABLET_WIDTH);
};

export const isMobileOrTabletUserAgent = (): boolean =>
  // only reccomended to use user agent sniffing as fallback
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
  /BlackBerry|webOS|iPhone|IEMobile|Android|Windows Phone|iPad|iPod/i.test(
    window.navigator.userAgent,
  );
